(function () {
  'use strict';
  if (window.__YF_LAZY_IFRAME_V2__) return;
  window.__YF_LAZY_IFRAME_V2__ = true;

  var tvCssStarted = false;

  function loadStylesheet(url, marker) {
    if (!url) return;
    if (marker && document.querySelector('link[' + marker + ']')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.media = 'print';
    if (marker) link.setAttribute(marker, 'true');
    link.onload = function () { link.media = 'all'; };
    document.head.appendChild(link);
  }

  function ensureTvCss() {
    if (tvCssStarted) return;
    tvCssStarted = true;
    var url = window.YF_PERF_ASSETS && window.YF_PERF_ASSETS.solidTvCss;
    loadStylesheet(url, 'data-yf-solid-tv-css');
  }

  function hydrate(frame) {
    if (!frame || frame.dataset.yfLazyHydrated === 'true') return;
    var lazySrc = frame.getAttribute('data-yf-lazy-src');
    if (!lazySrc) return;
    var current = frame.getAttribute('src') || '';
    // A user action may already have replaced the placeholder (for example Tap for Sound).
    if (current && current !== 'about:blank') {
      frame.dataset.yfLazyHydrated = 'true';
      frame.removeAttribute('data-yf-lazy-src');
      return;
    }
    frame.src = lazySrc;
    frame.dataset.yfLazyHydrated = 'true';
    frame.removeAttribute('data-yf-lazy-src');
  }

  function hydrateTv(section) {
    ensureTvCss();
    if (!section) return;
    section.querySelectorAll('iframe[data-yf-lazy-src]').forEach(hydrate);
  }

  function boot() {
    var frames = Array.prototype.slice.call(document.querySelectorAll('iframe[data-yf-lazy-src]'));
    var tvSections = Array.prototype.slice.call(document.querySelectorAll('.yf-solid-tv-section'));
    if (!frames.length && !tvSections.length) return;

    if ('IntersectionObserver' in window) {
      var observedTvFrames = new WeakSet();
      tvSections.forEach(function (section) {
        section.querySelectorAll('iframe[data-yf-lazy-src]').forEach(function (frame) { observedTvFrames.add(frame); });
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (entry.target.matches && entry.target.matches('.yf-solid-tv-section')) hydrateTv(entry.target);
          else hydrate(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '700px 0px' });

      tvSections.forEach(function (section) { observer.observe(section); });
      frames.forEach(function (frame) {
        if (!observedTvFrames.has(frame)) observer.observe(frame);
      });
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(function () {
          if (tvSections.length) ensureTvCss();
          frames.forEach(hydrate);
        }, 1800);
      }, { once: true });
    }
  }

  // One delegated handler replaces repeated inline scripts in each TV promo block.
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('.yf-solid-sound-button');
    if (!button) return;
    var section = button.closest('.yf-solid-tv-section');
    var frame = section && section.querySelector('iframe');
    if (!frame) return;
    ensureTvCss();
    var source = frame.getAttribute('data-yf-lazy-src') || frame.getAttribute('src') || '';
    if (source) {
      source = source.replace(/([?&])mute=1(?:&|$)/, function (match, sep) { return sep + 'mute=0&'; }).replace(/&$/, '');
      if (source.indexOf('autoplay=') === -1) source += (source.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      frame.src = source;
      frame.dataset.yfLazyHydrated = 'true';
      frame.removeAttribute('data-yf-lazy-src');
    }
    button.textContent = '🔊 Sound On';
    button.style.opacity = '0.75';
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
